module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub-main column"
  }, [_c('div', {
    staticClass: "sub-nav row"
  }, [_c('nav', _vm._l((_vm.menu), function(item) {
    return _c('router-link', {
      key: item.key,
      staticClass: "item",
      attrs: {
        "to": {
          name: item.uri
        }
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(item.name) + "\n\t\t\t")])
  }), 1)]), _vm._v(" "), _c('div', {
    staticClass: "sub-page center column"
  }, [_c('router-view')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c4a04594"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Transactions/index.vue
// module id = 1169
// module chunks = 0